/**
 * Whether the app has painted at least one screen this document load.
 *
 * The shell needs to tell a COLD DOCUMENT LOAD apart from a CLIENT-SIDE ARRIVAL when it mounts
 * for the first time — sign-in navigating into the gate is a real navigation the trainer should
 * hear announced, while a cold load already has the browser's own focus behaviour and stealing
 * it would be the bug. The shell cannot make that distinction alone: it mounts fresh in both
 * cases. What distinguishes them is whether anything ELSE painted first, and only the root can
 * know that.
 *
 * Effects run child-first, so on a cold load straight into the gate the shell's effect reads
 * `false` before the root's effect flips it — exactly the ordering the distinction needs.
 *
 * A module-scope flag, not state: nothing re-renders because of it, and it is per document load
 * by construction.
 */

let appHasPainted = false;

/** Called once from the root route's first effect, after the first screen has painted. */
export function markAppPainted(): void {
  appHasPainted = true;
}

/** True when some screen already painted this document load — i.e. a mount now is an arrival. */
export function hasAppPainted(): boolean {
  return appHasPainted;
}
